module.exports = __webpack_public_path__ + "media/assets/images/icons/profile-generic/profile-large-5e20112af033111cdcbab5530fdcc3e3.jpg";